import React from "react";

import queen_white from '../../img/q_w.svg';
import rook_white from '../../img/r_w.svg';
import bishop_white from '../../img/b_w.svg';
import knight_white from '../../img/n_w.svg';
import queen_black from '../../img/q_b.svg';
import rook_black from '../../img/r_b.svg';
import bishop_black from '../../img/b_b.svg';
import knight_black from '../../img/n_b.svg';

const whitePieces = [
    { piece: 'q', src: queen_white },
    { piece: 'r', src: rook_white },
    { piece: 'b', src: bishop_white },
    { piece: 'n', src: knight_white },
];

const blackPieces = [
    { piece: 'q', src: queen_black },
    { piece: 'r', src: rook_black },
    { piece: 'b', src: bishop_black },
    { piece: 'n', src: knight_black },
];

const overlayStyle = {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(10, 16, 64, 0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
};

const dialogStyle = {
    background: '#1a2878',
    border: '4px solid #3344aa',
    borderTop: '4px solid #5566cc',
    borderRadius: '8px',
    padding: '20px',
    display: 'flex',
    gap: '10px',
    boxShadow: '6px 8px 0px #0a1040',
};

const pieceButtonStyle = {
    width: '70px',
    height: '70px',
    cursor: 'pointer',
    border: '3px solid #2a3a8c',
    borderRadius: '6px',
    backgroundColor: '#0d1654',
    padding: '8px',
    transition: 'all 0.15s ease',
    boxShadow: '2px 2px 0px #0a1040',
};

const PromotionDialog = ({ color, onSelect }) => {
    const pieces = color === 'w' ? whitePieces : blackPieces;

    return (
        <div style={overlayStyle} onClick={(e) => e.stopPropagation()}>
            <div style={dialogStyle}>
                {pieces.map(({ piece, src }) => (
                    <button
                        key={piece}
                        style={pieceButtonStyle}
                        onClick={() => onSelect(piece)}
                        onMouseOver={(e) => {
                            e.currentTarget.style.backgroundColor = '#2a3a8c';
                            e.currentTarget.style.borderColor = '#ffd700';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.backgroundColor = '#0d1654';
                            e.currentTarget.style.borderColor = '#2a3a8c';
                        }}
                    >
                        <img src={src} alt={piece} style={{ width: '100%', height: '100%' }} />
                    </button>
                ))}
            </div>
        </div>
    );
};

export default PromotionDialog;
